import React, { useEffect, useState } from "react";
import SearchableDropdown from "../common/SearchableDropdown";
import { formatDateLong } from "../helper/formatters";
import CreateNotification from "./CreateNotification";
import { deleteAuthToken, notifyError } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { startLoader } from "../../_store/reducers/loaderReducer";
import { stopLoader } from "../../_store/reducers/loaderReducer";
import { getAllNotifications } from "../../requests";
import { useNavigate } from "react-router-dom";

const NotificationMngUI = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  
  const [type, setType] = useState("All");
  const [createNotification, setCreateNotification] = useState(false);

  const [data, setData] = useState([]);

  const options = ["All", "Push notifications", "Email notifications"];

  const FetchAllNotifications = async (pageVal) => {
    dispatch(startLoader());
    try {
      const response = await getAllNotifications({page: pageVal, limit: limit, type: type=="Push notifications" ? 1 : type=="Email notifications" ? 2 : "All"});
      setData(response.data.data);
      setTotalCount(response.data.total_count);
    
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    setPage(1);
    FetchAllNotifications(1);
   
  }, [type]);

  useEffect(() => {
    FetchAllNotifications(page);
  }, [page, limit]);

  return (
    <div className="tm-main">
      {createNotification && (
        <CreateNotification fn={() => setCreateNotification(false)} />
      )}
      <div className="overview-head">
        <div className="overview-head-left">Notification Management</div>
        <div className="overview-head-right">
          <SearchableDropdown
            options={[...options]}
            selected={type}
            setSelected={(e) => setType(e)}
            color="#E5E7EB"
            allowManualEntry={false}
          />
          <button
            className="my-btn"
            onClick={() => setCreateNotification(true)}
          >
            Create notification
          </button>
        </div>
      </div>

      <div className="teacher-table" style={{ borderTop: "none" }}>
        <div className="teacher-table-head">
          <div className="teacher-table-head-cell" style={{ width: "20%" }}>
            Notification title
          </div>

          <div className="teacher-table-head-cell" style={{ width: "25%" }}>
            Notification message
          </div>
          <div className="teacher-table-head-cell" style={{ width: "14%" }}>
            Notification type
          </div>
          <div className="teacher-table-head-cell" style={{ width: "25%" }}>
            Teacher email
          </div>

          <div className="teacher-table-head-cell" style={{ width: "16%" }}>
            Created at
          </div>
        </div>

        {data.length > 0 &&
          data.map((el, i) => (
            <div
              key={i}
              className="teacher-table-row"
              style={{ borderBottom: i == data.length - 1 && "none" }}
            >
              <div className="teacher-table-row-cell" style={{ width: "20%" }}>
                {el.title}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "25%" }}>
                {el.message || "-"}
              </div>
              <div className="teacher-table-row-cell" style={{ width: "14%" }}>
                {" "}
                {el.type == 1 ? "Push notification" : "Email notification"}
              </div>
              <div className="teacher-table-row-cell" style={{ width: "25%" }}>
                {el.email || "-"}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "16%" }}>
                {formatDateLong(el.created_at)}
              </div>
            </div>
          ))}
      </div>
      <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {data.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={ data.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  data.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (data.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
    </div>
  );
};

export default NotificationMngUI;
